import { render, staticRenderFns } from "./Moxingkuguanli.vue?vue&type=template&id=197db318&scoped=true&"
import script from "./Moxingkuguanli.vue?vue&type=script&lang=js&"
export * from "./Moxingkuguanli.vue?vue&type=script&lang=js&"
import style0 from "./Moxingkuguanli.vue?vue&type=style&index=0&id=197db318&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197db318",
  null
  
)

export default component.exports